<template>
  <div class="form-section mb-4">
    <h6 class="form-section-header mb-3">
      <i v-if="icon" :class="`fa ${icon} fa-fw me-2`" />

      <slot name="title">{{ title }}</slot>

      <small v-if="optional" class="text-muted fw-normal ms-1">({{ $t("optional") }})</small>
    </h6>

    <slot />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";

defineProps<{
  title?: string;
  icon?: string;
  optional?: boolean;
}>();

const { t: $t } = useI18n();
</script>

<style scoped lang="scss">
@import "@/assets/scss/_variables.scss";

.form-section-header {
  color: $primary;
  font-weight: 600;
  margin-bottom: 1rem;
}
</style>
